import { CheckOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import React, { FC, useEffect, useState } from "react";
import { Document } from "../PreAuthIhx";
import { Tooltip } from "antd";

type DocumentUploadIhxProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  portalSubmission: boolean;
  documentRequestResponseDocuments: any;
  handleSaveData: any;
  currentStage: any;
  activeKey: any;
  uploadFileList: any;
};

const ResponseDocumentUploadIhx: FC<DocumentUploadIhxProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  portalSubmission,
  documentRequestResponseDocuments,
  handleSaveData,
  currentStage,
  activeKey,
  uploadFileList,
}) => {
  const showData = currentStage?.visitStageId <= parseInt(activeKey);

  const [updatedDocumentUrls, setUpdatedDocumentUrls] = useState<any>();

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    setUpdatedDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        Response Document Upload
        {showData && portalSubmission ? (
          <Tooltip title={"Submit Response Documents"}>
            <CheckOutlined onClick={handleSaveData} />{" "}
          </Tooltip>
        ) : (
          <></>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          opacity: portalSubmission ? 1 : 0.5,
          pointerEvents: portalSubmission ? "auto" : "none",
        }}
      >
        {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 &&
          documentRequestResponseDocuments?.["responseDocuments"]?.map(
            (docType: any) => {
              //documentTypes?.map((docType: any) => {)
              const matchingDocuments = documentUrls?.filter(
                (doc) => doc.documentLabelType === docType.label
              );

              if (matchingDocuments?.length > 0 && !docType?.multiple) {
                return null;
              }

              return (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    // gap: 8,
                  }}
                >
                  {/* <div style={{ marginBottom: 8, fontWeight: "bold" }}>
                {docType.label}
              </div> */}

                  <Upload
                    multiple={docType?.multiple}
                    {...(docType?.multiple ? { fileList: uploadFileList } : {})}
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={
                      handleFileChange &&
                      handleFileChange(docType?.labelId, docType?.multiple)
                    }
                    disabled={!portalSubmission}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 0,
                        border: "none",
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                      }}
                      // disabled={!showData}
                      disabled={!portalSubmission}
                    ></Button>
                  </Upload>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: 0,
                        border: "none",
                        paddingLeft: 0,
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                      iconPosition={"end"}
                      // icon={
                      //   matchingDocuments?.length > 0 ? (
                      //     <EyeOutlined
                      //       style={{ marginLeft: "0.6rem" }}
                      //       onClick={() => {
                      //         handleOpen(
                      //           matchingDocuments?.[0]?.documentLabelType
                      //         );
                      //       }}
                      //     />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    >
                      {docType.label}{" "}
                      {docType?.required ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </div>

                  {/* {matchingDocuments?.length > 0 && (
                // <ul style={{ marginTop: 10, paddingLeft: 0 }}>
                //   {matchingDocuments.map((doc, i) => (
                //     <li
                //       key={i}
                //       style={{
                //         listStyle: "none",
                //         display: "flex",
                //         justifyContent: "space-between",
                //         alignItems: "center",
                //         padding: "6px 0",
                //         borderBottom: "1px solid #f0f0f0",
                //       }}
                //     >
                //       <a
                //         href={doc.documentUrl}
                //         target="_blank"
                //         rel="noreferrer"
                //       >
                //         {doc.documentName || `Document ${i + 1}`}
                //       </a>
                //       <Button
                //         danger
                //         type="link"
                //         icon={<DeleteOutlined />}
                //         onClick={() =>
                //           handleDeleteList(doc.documentType, doc.documentUrl, i)
                //         }
                //       />
                //     </li>
                //   ))}
                // </ul>

                <EyeOutlined
                  style={{ marginLeft: "0.6rem" }}
                  onClick={() => {
                    handleOpen();
                  }}
                />
              )} */}
                </div>
              );
            }
          )}
      </div>
      {/* 
      {
        showData ? <Button
         type="primary"
         style={{
           backgroundColor: "rgb(0, 76, 143)",
           color: "#fff",
           boxShadow: "0px 2px 8px 0px #00000040",
           width: "10%",
           marginTop: 10,
           opacity: portalSubmission ? 1 : 0.5,
          pointerEvents: portalSubmission ? "auto" : "none",
         }}
         onClick={handleSaveData}
       >
         Save
       </Button> : <></>
      } */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop:
            updatedDocumentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {/* {updatedDocumentUrls?.map((docType: any, index: any) => (
          <div
            key={docType.id}
            style={{
              border: "1px solid #eee",
              padding: 10,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",

              // gap: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                style={{
                  borderRadius: "6px",
                  border: "none",
                  paddingLeft: 20,
                  // borderTopRightRadius: "6px",
                  // borderBottomRightRadius: "6px",
                  background: docType?.deficiencyCheckStatus
                    ? "rgb(0, 109, 119)"
                    : docType?.deficiencyCheckStatus === "false" ||
                      docType?.deficiencyCheckStatus === false
                    ? "#DD2025"
                    : "#fff",
                  color:
                    docType?.deficiencyCheckStatus ||
                    docType?.deficiencyCheckStatus === false
                      ? "white"
                      : "black",
                }}
                iconPosition={"end"}
                icon={
                  <EyeOutlined
                    style={{ marginLeft: "0.6rem" }}
                    onClick={() => {
                      handleOpen(docType?.documentLabelType);
                    }}
                  />
                }
              >
                {docType?.documentLabelType} {index+1}{" "}
              </Button>
            </div>
          </div>
        ))} */}

        {Object.entries(groupByLabelType(updatedDocumentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                          docType?.deficiencyCheckStatus === false
                        ? "#DD2025"
                        : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(docType?.documentLabelType, docType?.documentUrl);
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default ResponseDocumentUploadIhx;
